import React from 'react';
import LeadsFaq from './LeadsFaq';
import WithCsportalAuth from '../../hooks/WithCsportalAuth';
import FaqWrapper from '../common/FaqWrapper';

function Leads() {
  return (
    <>
      <LeadsFaq />
    </>
  );
}

export default WithCsportalAuth(FaqWrapper(Leads));
